import { Component, EventEmitter, Input, Output, Injector } from '@angular/core';
import { AuthService } from '../../../service/auth-service/auth-service.service';
import { Art57Node } from '../../../ui/Node/Art57Node/Art57Node';
import { Art57NodeList } from '../../../ui/Node/Art57Node/Art57NodeList';
import { TreeNodeXEVPRMMessage } from '../../../ui/Node/Art57Node/Entity/TreeNodeXEVPRMMessage';
import { TreeNodeATCCodeList } from '../../../ui/Node/Art57Node/ListEntity/TreeNodeATCCodeList';
import { TreeNodeAttachmentList } from '../../../ui/Node/Art57Node/ListEntity/TreeNodeAttachmentList';
import { TreeNodeMasterFileLocationList } from '../../../ui/Node/Art57Node/ListEntity/TreeNodeMasterFileLocationList';
import { TreeNodeOldDrugIngredientsList } from '../../../ui/Node/Art57Node/ListEntity/TreeNodeOldDrugIngredientsList';
import { TreeNodeOrganisationList } from '../../../ui/Node/Art57Node/ListEntity/TreeNodeOrganisationList';
import { TreeNodePharmaceuticalFormList } from '../../../ui/Node/Art57Node/ListEntity/TreeNodePharmaceuticalFormList';
import { TreeNodePreviousEVCodeList } from '../../../ui/Node/Art57Node/ListEntity/TreeNodePreviousEVCodeList';
import { TreeNodeProductsList } from '../../../ui/Node/Art57Node/ListEntity/TreeNodeProductsList';
import { TreeNodeRoutesOfAdministrationList } from '../../../ui/Node/Art57Node/ListEntity/TreeNodeRoutesOfAdministrationList';
import { TreeNodeSourceList } from '../../../ui/Node/Art57Node/ListEntity/TreeNodeSourceList';
import { TreeNodeSubstancesList } from '../../../ui/Node/Art57Node/ListEntity/TreeNodeSubstancesList';
import { Art57NodeUtils } from '../../../ui/Node/Art57Node/Art57NodeUtils';
import { XevprmSubmissionService } from '../../../service/xevprm-submission-service/xevprm-submission.service';

@Component({
  selector: 'app-product-toolbox',
  templateUrl: './product-toolbox.component.html',
  styleUrl: './product-toolbox.component.scss'
})
export class ProductToolboxComponent {
  @Input() selectedNode: any;
  @Input() fieldsErrorsControl: any;
  @Output() buttonAction = new EventEmitter();
  
  public sendMessageLoading$ = this.injector.get(XevprmSubmissionService).loading; // Expose loading observable for template via async pipe
  
  constructor(public authService: AuthService,
              public injector: Injector) {}

  onButtonAction(buttonAction: String, parameter: string = '') {
    const data = { action: buttonAction, param: parameter };
    this.buttonAction.emit(data);
  };

  isTreeNodeXEVPRM_MESSAGE() {
    return (this.selectedNode instanceof TreeNodeXEVPRMMessage);
  }

  isListViewNode() {
    return (this.selectedNode instanceof Art57NodeList);
  }

  isCustomListNode() {
    return this.isProductsList() ||
      this.isSubstancesList() ||
      this.isOrganisationsList() ||
      this.isATCCodesList() ||
      this.isPharmaceuticalFormsList() ||
      this.isRoutesOfAdministrationsList() ||
      this.isAttachmentsList() ||
      this.isPreviousEVCodeList() ||
      this.isOldDrugIngredientList();
  }

  isProductsList() {
    return (this.selectedNode instanceof TreeNodeProductsList)
  }

  isSubstancesList() {
    return (this.selectedNode instanceof TreeNodeSubstancesList)
  }

  isSourcesList() {
    return this.selectedNode instanceof TreeNodeSourceList
  }

  isOrganisationsList() {
    return (this.selectedNode instanceof TreeNodeOrganisationList)
  }

  isATCCodesList() {
    return this.selectedNode instanceof TreeNodeATCCodeList
  }

  isPharmaceuticalFormsList() {
    return this.selectedNode instanceof TreeNodePharmaceuticalFormList
  }

  isRoutesOfAdministrationsList() {
    return this.selectedNode instanceof TreeNodeRoutesOfAdministrationList
  }

  isAttachmentsList() {
    return this.selectedNode instanceof TreeNodeAttachmentList
  }

  isMastgerFileLocationsList() {
    return this.selectedNode instanceof TreeNodeMasterFileLocationList
  }

  isPreviousEVCodeList() {
    return this.selectedNode instanceof TreeNodePreviousEVCodeList
  }

  isOldDrugIngredientList() {
    return this.selectedNode instanceof TreeNodeOldDrugIngredientsList
  }

  isEnabledSelectAll() {
    const atLeastOneItemUnChecked = (this.selectedNode as Art57Node).children?.find(child => !child.checked);
    return atLeastOneItemUnChecked;
  }

  isEnabledDeselectAll() {
    const atLeastOneItemChecked = (this.selectedNode as Art57Node).children?.find(child => child.checked);
    return atLeastOneItemChecked;
  }

  isSelectAllVisible() {
    const isSelectVisible = (this.selectedNode as Art57Node).children?.find(child => child.data);
    return isSelectVisible;
  }

  isOperationTypeInsert() {
    let result = false;
    const parentNode = Art57NodeUtils.findAscendantObjectWithDataProperty(this.selectedNode, "operationtype");
    result = parentNode && parentNode.data.model.operationtype === 1;
    return result;
  }

  showDuplicateButton() {
    return (!this.isListViewNode()) && (!this.isTreeNodeXEVPRM_MESSAGE()) && this.isOperationTypeInsert()
  }
}
